export const darkTheme = {
    // main background
    bg : "#181818",
    // menu bg
    bgLighter : "#202020",
    // main text
    text : "white",
    //small text or heading text
    textSoft : "#aaaaaa",
    //Hr lines
    soft : "#373737"
}

export const lightTheme = {
  bg: "#f9f9f9",
  bgLighter : "white",
  text : "black",
  textSoft : "#606060",
  soft : "#f5f5f5"
}